<template>
  <div class="sing-question-view">
<!--    <div class="question-desc-view">{{questionData.desc}}</div>-->
    <div class="sing-question-info-view">
      <template
        v-if="questionData.content_audio&&questionData.content_audio!=''&&questionData.content_audio!=null">
        <div class="sing-play-btn"
             @click="playsing(questionData.content_audio)">
          <div>听力材料</div>
        </div>
      </template>
      <div class="question-contenttext-view" v-if="questionData.content_img.length>0">
        <el-image :src="baseurl+questionData.content_img" class="options-img-view" lazy>
          <div slot="placeholder" class="image-slot">
            <img src="../../assets/img/question-loading.png">
          </div>
          <div slot="error" class="image-slot">
            <img src="../../assets/img/question-loading.png">
          </div>
        </el-image>
      </div>
      <template v-if="questionData.content&&questionData.content!=''&&questionData.content!=null">
        <div class="sing-content-view" v-html="formathtml(questionData.content)"></div>
      </template>
      <div class="sing-options-view" :class="questionData.option_type==2?'sing-options-view1':''">
        <template v-for="(itemoption,itemindex) in getOptions(questionData.options)">
          <template v-if="questionData.option_type==1">
            <div :id="'chose'+itemindex" class="sing-options-item-view"
                 :class="questionData.useroption==itemoption?'sing-select-option-view':''"
                 @click="chosethis(itemoption)">
              <span v-if="questionData.show_type==1">{{optionchart[itemindex]+"、"+itemoption}}</span>
              <span v-if="questionData.show_type==2">{{itemoption}}</span>
            </div>
          </template>
          <template v-else>
            <div :id="'chose'+itemindex" @click="chosethis(itemoption)">
              <el-image :src="baseurl+itemoption" class="sing-options-img-view "
                        :class="questionData.useroption==itemoption?'sing-select-option-view':''"
                        style="width: 180px; height: 180px" lazy>
              </el-image>
              <div class="option-chart-div">{{optionchart[itemindex]}}</div>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import apiUtil from "@/api/apiUtils"
  import Apis from "@/api"

  export default {
    name: "singquestion",
    data() {
      return {
        showdesc: true,
        audiourl: "",
        baseurl: apiUtil.getBaseUrl(),
        localindex: 0,
        totalindex: 0,
        pageindex: 0,
        descplay: false,
        contentplay: false,
        optionchart:this.getOptionIndex()
      }
    },
    props: {
      questionData: {
        type: Object,
        default: function () {
          return {}
        }
      }
    },
    mounted() {
    },
    watch: {
      "questionData": function () {
        console.log(this.questionData.useroption)
      }
    },
    methods: {
      questionfinishs(msg) {
        var questioninfo = JSON.parse(JSON.stringify(this.questionData));
        questioninfo.isfinish = true
        questioninfo.useroption = msg
        this.$emit("questionfinish", questioninfo)
        this.$forceUpdate()
      },
      chosethis(itemoption) {
        this.questionfinishs(itemoption)
        this.$forceUpdate()
      },
      playsing(msg) {
        var that = this;
        that.$emit("playsing", this.baseurl + msg)
      },
      getOptions(options) {
        return options.split("|").sort()
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../assets/css/common.styl";
  .sing-question-view {
    width 100%;
    height 100%;



    .sing-play-btn {
      margin 10px auto;
      width 240px;
      height 60px;
      display flex;
      background url("../../assets/img/question-device-bg.png")
      background-size 100% 100%;
      align-items center;
      color #5D79FA;
      font-size 30px;

      & > div {
        margin-left 80px;
      }
    }
    .question-contenttext-view {
      margin-top: 10px;
      margin-bottom: 15px;
      font-size: 60px;
      color: #131313;
      font-family: Arial;
    }

    .question-contenttext-view img {
      width: 160px;
      height: 160px;
      border-radius: 12px;
      border: 3px solid #131313;
    }
    .sing-content-view {
      font-size 26px;
    }

    .sing-question-info-view {
      display flex;
      flex-direction column;
      justify-content start;
    }

    .sing-options-view {
      align-self: center;
      width: 95%;
      margin-top 50px;
      flex-wrap: wrap;
      display: flex;
      justify-content: space-between;

    }

    .sing-options-view1 {
      align-self: center;
      width: 95%;
      flex-wrap: wrap;
      display: flex;
      justify-content: center;
    }

    .sing-select-option-view {
      border: 3px solid #92C761 !important;
    }

    .sing-options-item-view {
      width: 40%;
      word-wrap: break-word;
      text-align: left;
      font-size: 36px;
      max-width: 40%;
      margin: 5px 2%;
      border-radius: 12px;
      padding: 10px;
      border: 3px solid #000;
      position: relative;
    }

    .sing-options-item-view span {
      position: relative;
    }

    .sing-options-img-view {
      border-radius: 12px;
      position: relative;
      margin 10px;
      border: 3px solid #000;
    }
    .option-chart-div{
      font-size 23px;
    }

    .sing-options-img-view img {
      width: 180px;
      height: 180px;
      border-radius: 11px;
      position: relative;
      left: -1px;
    }

    .sing-options-item-img-view {
      width: 180px;
      height: 180px;
      border: 3px solid #000;
      border-radius: 12px;
      position: relative;
      margin: auto 10px;
    }

    .image-slot img {
      width: 178px;
      height: 178px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/public/singquestion.vue